/* import __COLOCATED_TEMPLATE__ from './printable-check-cancel-dialog.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();